/**
 * Maps page routes to their background colors
 * Used by PageTransition to match transition panel colors to source pages
 */

const PAGE_COLORS: Record<string, string> = {
  // Main pages
  '/': '#FFDC32', // Home - yellow
  '/what-we-do': '#D7CEFF', // What We Do - purple
  '/about': '#9BC9FF', // About - blue
  '/careers': '#C0FDB0', // Careers - green
  '/work': '#FDFEF6', // Work listing - eggshell (default)
  '/contact': '#FDFEF6', // Contact - eggshell (default)
  '/services': '#FDFEF6', // Services - eggshell (default)
  
  // Case studies with custom colors
  '/case-studies/brooklyn-film-festival': '#E5FC54', // Brooklyn Film Festival - lime
  '/case-studies/staybl': '#3260DE', // Staybl - blue
  '/case-studies/google-fitbit': '#D3F1F3', // Google Fitbit - light blue/cyan
  
  // Default for case studies (black)
  // All /work/[slug] routes default to #000000
  // All other /case-studies/* routes default to #000000
};

/**
 * Get the background color for a given route
 * @param pathname - The route pathname (e.g., '/about', '/work/american-airlines')
 * @returns The background color hex code
 */
export function getPageBackgroundColor(pathname: string): string {
  // Check exact match first
  if (PAGE_COLORS[pathname]) {
    return PAGE_COLORS[pathname];
  }
  
  // Check if it's a case study route
  if (pathname.startsWith('/work/') || pathname.startsWith('/case-studies/')) {
    // Check for specific case study mappings
    if (PAGE_COLORS[pathname]) {
      return PAGE_COLORS[pathname];
    }
    // Default to black for case studies
    return '#000000';
  }
  
  // Default to eggshell for unknown routes
  return '#FDFEF6';
}

